<div>
    <div class="dx-card wide-card">
        <h4 class="content-block ap-green">SAP Volume Better Served For CO2</h4>
        <div class="content-block">
            <form #form="ngForm" (ngSubmit)="viewReport()" autocomplete="off" showValidationSummary="true">
                <dx-validation-group>
                    <dx-responsive-box singleColumnScreen="xs sm md">
                        <dxi-row [ratio]="1"></dxi-row>
                        <dxi-row [ratio]="1"></dxi-row>
                        <dxi-col [ratio]=".5"></dxi-col>
                        <dxi-col [ratio]=".3"></dxi-col>
                        <dxi-col [ratio]=".2"></dxi-col>
                        <dxi-item>
                            <dxi-location [row]="0" [col]="0"></dxi-location>
                            <div class="dx-field">
                                <div class="dx-field-label"> Proposed Plants </div>
                                <div class="boxwidth">
                                    <dx-drop-down-box style="width: 100%;" #plantsDropDown [(value)]="plantValue"
                                        placeholder="Select a value..." [showClearButton]="true"
                                        [dataSource]="proposedPlantsData" valueExpr="siteID" displayExpr="siteCombined"
                                        (onValueChanged)="onPlantsDropDownBoxValueChanged($event)"
                                        validationMessagePosition="top">
                                        <div *dxTemplate="let data of 'content'">
                                            <dx-list #plantslist [dataSource]="proposedPlantsData" [height]="300"
                                                [selectionMode]="'all'" [selectAllMode]="'allPages'"
                                                [showSelectionControls]="true" keyExpr="siteID"
                                                displayExpr="siteCombined"
                                                (onSelectionChanged)="onsegmentListSelectionChanged($event)"
                                                scrollingEnabled="true">
                                            </dx-list>
                                        </div>
                                        <dx-validator>
                                            <dxi-validation-rule type="required"
                                                message="Please select atleast one plant.">
                                            </dxi-validation-rule>
                                        </dx-validator>
                                    </dx-drop-down-box>
                                </div>
                            </div>
                        </dxi-item>
                        <dxi-item>
                            <dxi-location [row]="0" [col]="1"></dxi-location>
                            <div class="dx-field">
                                <div class="dx-field-label"> Can Cross Borders </div>
                                <div style="width: 50%" class="leftmargin">
                                    <dx-radio-group [items]="cancrossbordersdata" valueExpr="value" displayExpr="text"
                                        [(value)]="cancrossborders" layout="horizontal"></dx-radio-group>
                                </div>
                            </div>
                        </dxi-item>
                        <dxi-item>
                            <dxi-location [row]="0" [col]="2"></dxi-location>
                            <div class="dx-field rightalign">
                                <dx-button class="ap-blue-btn" [useSubmitBehavior]="true" text="View Reports">
                                </dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item>
                            <dxi-location [row]="1" [col]="0"></dxi-location>
                            <div class="dx-field">
                                <div class="dx-field-label"> Trailer Size (MT)</div>
                                <div class="boxwidth">
                                    <dx-text-box [(value)]="trailerSize">
                                        <dx-validator>
                                            <dxi-validation-rule type="required" message="Please enter Trailer Size.">
                                            </dxi-validation-rule>
                                            <dxi-validation-rule type="pattern" [pattern]="numberPattern"
                                                message="Only numbers are allowed.">
                                            </dxi-validation-rule>
                                        </dx-validator>
                                    </dx-text-box>
                                </div>
                            </div>
                        </dxi-item>
                        <dxi-item>
                            <dxi-location [row]="1" [col]="1"></dxi-location>
                            <div class="dx-field">
                                <div class="dx-field-label"> Distribution Cost ($/mi)</div>
                                <div class="dx-field-value">
                                    <dx-text-box [(value)]="distributionCost">
                                        <dx-validator>
                                            <dxi-validation-rule type="required"
                                                message="Please enter Distribution Cost.">
                                            </dxi-validation-rule>
                                            <dxi-validation-rule type="pattern" [pattern]="decimalPattern"
                                                message="Only numbers are allowed.">
                                            </dxi-validation-rule>
                                        </dx-validator>
                                    </dx-text-box>
                                </div>
                            </div>
                        </dxi-item>
                        <div>
                            <dx-validation-summary></dx-validation-summary>
                        </div>
                    </dx-responsive-box>
                </dx-validation-group>
            </form>
            <hr />
        </div>
        <dx-load-panel #dxLoadPanel shadingColor="rgba(0,0,0,0.4)" [visible]="isLoadPanelVisible" [showPane]="true"
            [shading]="false" [closeOnOutsideClick]="false">
        </dx-load-panel>
        <div class="topmargin" *ngIf="showReport">
            <h4 class="content-block">Current CO2 Customers Better Served By Proposed Plant, All Segments</h4>
            <h5 class="content-block">Saved $/yr" is calculated using the trailer size and distribution cost entered in
                the top of the report.</h5>

            <dx-data-grid class="gridmargin" id="gridContainer" [dataSource]="dataSource"
                [remoteOperations]="{ groupPaging: false }" [wordWrapEnabled]="true" [showBorders]="true">
                <dxo-scrolling mode="virtual"></dxo-scrolling>
                <dxo-group-panel [visible]="true"></dxo-group-panel>
                <dxo-grouping #expand [autoExpandAll]="false"></dxo-grouping>
                <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
                <dxo-toolbar>
                    <dxi-item name="groupPanel"></dxi-item>
                    <dxi-item location="after">
                        <dx-button icon="exportxlsx" class="ap-blue-btn" (onClick)="exportExcel($event)"
                            text="Export to Excel">
                        </dx-button>
                    </dxi-item>
                </dxo-toolbar>

                <dxi-column dataField="proposedPlant" [groupIndex]="0" caption="Proposed Plant"></dxi-column>
                <dxi-column dataField="prod" [groupIndex]="1" caption="Prod"></dxi-column>
                <dxi-column dataField="formerPlant" [groupIndex]="2" caption="Former Plant"></dxi-column>
                <dxi-column dataField="customer" caption="Customer"></dxi-column>
                <dxi-column dataField="oldMiles" caption="Old Miles"></dxi-column>
                <dxi-column dataField="newMiles" caption="New Miles"></dxi-column>
                <dxi-column dataField="mTperDay" caption="MT/Day"></dxi-column>
                <dxi-column dataField="saveddollar" format="currency" caption="Saved $/yr"></dxi-column>
                <dxi-column dataField="customerCount" caption="Customer Count"></dxi-column>
                <dxi-column dataField="tankCount" caption="Tank count"></dxi-column>
                <dxi-column dataField="sapCustomerID" caption="sapCustomerID"></dxi-column>
                <dxo-summary>
                    <dxi-group-item [alignByColumn]="true" [customizeText]="getSumValueOnly" column="mTperDay"
                        summaryType="sum"> </dxi-group-item>
                    <dxi-group-item [alignByColumn]="true" [customizeText]="getDollerValueOnly" column="saveddollar"
                        summaryType="sum"> </dxi-group-item>
                    <dxi-group-item [alignByColumn]="true" [customizeText]="getCountValueOnly" column="customerCount"
                        summaryType="sum"> </dxi-group-item>
                    <dxi-group-item [alignByColumn]="true" [customizeText]="getCountValueOnly" column="tankCount"
                        summaryType="sum"> </dxi-group-item>
                </dxo-summary>
            </dx-data-grid>
        </div>
    </div>
</div>